import React, { memo, forwardRef } from "react";
const SvgLiteralset = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M2.544 16.891c-.522-.162-.783-.459-.783-.891s.261-.729.783-.891c.54-.18.927-.513 1.161-.999.252-.486.378-1.215.378-2.187V7.387c0-1.188.27-2.043.81-2.565.54-.54 1.377-.81 2.511-.81h.675c.54 0 .81.243.81.729s-.27.729-.81.729h-.54c-.63 0-1.07.189-1.323.567-.234.36-.35.918-.35 1.674v4.617c0 2.034-.802 3.249-2.404 3.645v.054c1.602.396 2.403 1.611 2.403 3.645v4.617c0 .756.117 1.314.351 1.674.252.378.693.567 1.323.567h.54c.54 0 .81.243.81.729s-.27.729-.81.729h-.675c-1.134 0-1.97-.27-2.51-.81-.54-.522-.81-1.377-.81-2.565v-4.536c0-.972-.127-1.701-.379-2.187-.234-.486-.62-.819-1.16-.999zM29.456 15.109c.522.162.783.459.783.891s-.261.729-.783.891c-.54.18-.936.513-1.188.999-.234.486-.351 1.215-.351 2.187v4.536c0 1.188-.27 2.043-.81 2.565-.54.54-1.377.81-2.511.81h-.675c-.54 0-.81-.243-.81-.729s.27-.729.81-.729h.54c.63 0 1.062-.189 1.296-.567.252-.36.378-.918.378-1.674v-4.617c0-2.034.801-3.249 2.403-3.645v-.054c-1.602-.396-2.403-1.611-2.403-3.645V7.711c0-.756-.126-1.314-.378-1.674-.234-.378-.666-.567-1.296-.567h-.54c-.54 0-.81-.243-.81-.729s.27-.729.81-.729h.675c1.134 0 1.971.27 2.511.81.54.522.81 1.377.81 2.565v4.536c0 .972.117 1.701.351 2.187.252.486.648.819 1.188.999z"
      />
      <rect width={10} height={14} x={10.95} y={8.776} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgLiteralset.displayName = "SvgLiteralset";
const MemoForwardRef = memo(SvgLiteralset);
export default MemoForwardRef;
